import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { TournamentsRequestFormatter } from "../TournamentsRequestFormatter/TournamentsRequestFormatter";
export function createTournamentsConnection() {
    return createRESTConn({
        name: ConnectionNames.tournaments,
        handlers: {
            requestFormatter: TournamentsRequestFormatter
        }
    });
}
//# sourceMappingURL=CreateTournamentsConnection.js.map